import React from 'react';
import AnnouncementBasicInfoComponent from './announcememt-basic-info.component';
import { useSelector } from 'react-redux';
import { UOMInfoComponent } from './announcement-uon-info.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';


function AnnouncementComponent({ handleInnerFormItemChange, organizationUnits, handleFormItemChange, mediaFiles, changeImage, id, announcementType, handleInnerFormChange, back, handleFormSubmit, selectedAnnouncement }: any) {
    const libraryData = useSelector(selectListItems)
    const tabItems = [
        {
            id: 1,
            title: 'Basic Information',
            component: <AnnouncementBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedAnnouncement={selectedAnnouncement}
                announcementType={announcementType}

            />,
            isVisible: true,
        },
        //         {
        //             id: 2,
        //             title: 'Media ',
        //             component: <MediaInfoComponent
        //             changeImage={changeImage}
        //             fileTypes={libraryData?.result?.FileType}
        //             onFormItemChange={handleFormItemChange}
        //             mediaFiles={mediaFiles}
        //             />,
        // isVisible:id > 0 ? true : false,
        //         },
        //         {
        //             id: 3,
        //             title:'Organization Unit Info',
        //             component: <UOMInfoComponent
        //             selectedAnnouncement={selectedAnnouncement}
        //             handleInnerFormItemChange={handleInnerFormItemChange}
        //             organizationUnits={organizationUnits}
        //             />,
        // isVisible: true,
        //         },

    ]
    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
}
export default AnnouncementComponent;
